import {
  superadminMenuSections as baseSuperadminMenuSections,
  userMenuSections,
  operatorMenuSections,
  coordinatorMenuSections,
  servicemanMenuSections,
  companyManagerMenuSections as baseCompanyManagerMenuSections,
  Menu,
  TopMenu,
  SectionMenuPopup,
} from '@/pages/dashboard/menu/menus';
import { isNFCSupported } from '../../tools/nfc/writer';

export {
  userMenuSections,
  operatorMenuSections,
  coordinatorMenuSections,
  servicemanMenuSections,
  Menu,
  TopMenu,
  SectionMenuPopup,
};

export const superadminMenuSections: typeof baseSuperadminMenuSections = (props) => {
  const sections = baseSuperadminMenuSections(props)

  return sections.map((section) => {
    if (section.group !== 'special') return section

    return {
      ...section,
      items: [
        ...(section.items ?? []),
        ...(isNFCSupported() ? [{ url: '/tool/nfc/pgswriter', name: 'menu.nfcwriter' }] : []),
        // add more items here...
      ],
    }
  })
}

export const companyManagerMenuSections: typeof baseCompanyManagerMenuSections = (props) => {
  const sections = baseCompanyManagerMenuSections(props)

  return sections.map((section) => {
    if (section.group !== 'special') return section

    return {
      ...section,
      items: [
        ...(section.items ?? []),
        ...(isNFCSupported() ? [{ url: '/tool/nfc/pgswriter', name: 'menu.nfcwriter' }] : []),
      ],
    }
  })
}
